<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of lastBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="btnHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'AgreementBtn',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        btnList: [
          {
            title: '保存',
            type: 'primary',
            clickName: 'handleSave',
            params: 0,
            key: 'save',
          },
          {
            title: '提交审批',
            type: 'primary',
            clickName: 'handleSave',
            params: 1,
            key: 'approval',
          },
          {
            title: '复制',
            type: 'primary',
            clickName: 'copyBtnHandler',
            key: 'copy',
          },
          {
            title: '删除',
            type: 'danger',
            clickName: 'deleteBtnHandler',
            key: 'delete',
          },
          {
            title: '创建采购合同',
            type: 'primary',
            clickName: 'createContractBtnHandler',
            key: 'createContract',
          },
          {
            title: '确认撤销',
            type: 'warning',
            clickName: 'confirmCancelHandler',
            key: 'confirmCancel',
            params: '1',
          },
          {
            title: '驳回撤销',
            type: 'warning',
            clickName: 'confirmCancelHandler',
            key: 'rejectCancel',
            params: '0',
          },
        ],
        lastBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      btnHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      disabledBtnHandler(contractStatus) {
        this.lastBtnList = this.btnList.map((item) => {
          if (this.$route.query.isCopy == 'true' && this.$route.query.isEdit == 'false') {
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
          if (['ZT00', 'ZT05', 'ZT06'].includes(contractStatus)) {
            // 已保存
            if (['save', 'delete', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (['ZT02', 'ZT024'].includes(contractStatus)) {
            // 审批中
            return {
              ...item,
              disabled: true,
            };
          } else if (contractStatus == 'ZT03') {
            if (['copy', 'createContract'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT022') {
            // 撤回审批中
            if (['rejectCancel', 'confirmCancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT025') {
            return {
              ...item,
              disabled: true,
            };
          } else {
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = !this.lastBtnList.every((item) => item.disabled);
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          this.disabledBtnHandler(val);
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
